import React, { useContext, useEffect, useRef, useState } from 'react';
import { NeuroMessage, useGuideConfig, useProduct } from '@ignitesales/neuro-application';
import ContactFlow from '@ignitesales/neuro-application/src/neuro-guide/components/ContactFlow/ContactFlow';
import { defaultBusinessFields, defaultConsumerFields } from '@ignitesales/neuro-application/src/neuro-guide/components/ContactFlow/ContactForm';
import { ToggleMenu } from "@ignitesales/neuro-application/src/neuro-ui";
import PropTypes from 'prop-types';
import GuideContext from '../GuideContext';

const CompleteGuideFlow = ({
  formIsVisible,
  contactFlowClicked,
  contactFormSubmitted,
  onCloseForm,
  onFormSubmission,
}) => {
  const cssBEM = 'completeGuideFlow';
  const guideContext = useContext(GuideContext);
  const { isBranchGuide } = useGuideConfig();
  const [ skipEmailWithLead, setSkipEmailWithLead ] = useState(false);
  const { product, setProduct } = useProduct();
  const formSchema = guideContext.isBusinessGuide
    ? defaultBusinessFields
    : [ 
      ...defaultConsumerFields, 
      {
        name: 'customerId',
        type: 'text'
      },
    ];
  const validators = {
    firstName: {
      matchPattern: "^(?=\.{1,40}$)[a-zA-Z ,.'-]*$",
      maxLength: '100'
    },
    lastName: {
      matchPattern: "^(?=\.{1,40}$)[a-zA-Z ,.'-]*$",
      maxLength: '100'
    },
    email: {
      matchPattern:
        '^([0-9a-zA-Z]+([-.\\w][0-9a-zA-Z]+)*@([0-9a-zA-Z][-\\w]*[0-9a-zA-Z].)+[a-zA-Z]{2,9})$',
      maxLength: '100'
    },
    customerId: {
      matchPattern: "^(?=\.{0,40}$)[0-9a-zA-Z ,.'-]*$",
      maxLength: '100'
    },
    phone: {},
  };

  const fields = formSchema.map( (name, index) => ({
    ...formSchema[index],
    ...validators?.[formSchema[index].name],
  }));

  const formSubmitted = (lead) => {
    onFormSubmission(lead, !skipEmailWithLead);
  };

  const handleCloseForm = () => {
    if (product?.url) {
      contactFormSubmitted && window.open(product.url, '_blank');
      setProduct(null);
    }

    onCloseForm();
  };

  const focusContactForm = useRef();

  // @TODO Can Add back in and remove focus code from Summary Page once Toggle Package is updated
  // to forward ref
  useEffect(() => {
    if (formIsVisible) {
      focusContactForm.current.focus();
    }
  }, [formIsVisible]);

  return (
    <ToggleMenu
      className={cssBEM}
      animation="slideFromRight"
      isOpen={formIsVisible}
      onOuterClick={handleCloseForm}
      ref={focusContactForm}
    >
      <button
        onClick={handleCloseForm}
        className={`btn btn-primary ${cssBEM}__close`}
        aria-label="Close"
        ref={focusContactForm}
        tabIndex="0"
      >
        <i className="fa fa-close" role="img" aria-label="Close" />
      </button>
      <div className={`${cssBEM}__title`}>
        <NeuroMessage
          id={
            contactFormSubmitted ? 'contactMe.success.title' : 'contactMe.title'
          }
          tagName="h1"
        />
        <NeuroMessage
          id={
            contactFormSubmitted
              ? 'contactMe.success.message'
              : 'contactMe.subtitle'
          }
          tagName="p"
        />
      </div>

      <div className={`${cssBEM}__steps`}>
        <section>
          {!contactFormSubmitted && (
            <ContactFlow
              hasBeenClicked={contactFlowClicked}
              guideType="consumer"
              // @TODO Make sure this Guide Flow should be left open for success message
              onComplete={() => {}}
              onContactFormSubmit={formSubmitted}
              {...(isBranchGuide && {fields})}
              shouldValidateOnBlur
              validators={validators}
            >
              <label
                className={ skipEmailWithLead ? 'skipEmailWithLeadLabel checked' : 'skipEmailWithLeadLabel' }
                onClick={ () => setSkipEmailWithLead(!skipEmailWithLead) }
              >
                <NeuroMessage id='skipEmailWithLeadMsg' />
              </label>
            </ContactFlow>
          )}
        </section>
      </div>
    </ToggleMenu>
  );
};

CompleteGuideFlow.propTypes = {
  formIsVisible: PropTypes.bool,
  closeForm: PropTypes.func,
};

export default CompleteGuideFlow;
